"use client";

import Link from "next/link";
import { Send } from "lucide-react";
import Image from "next/image";

export function Footer() {
  return (
    <footer className="bg-[#0C1113] text-white py-12 border-t border-gray-800/50">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand & Socials */}
          <div className="flex flex-col items-start">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://pulsarmoney.b-cdn.net/rhuna/rhuna_icon.png" 
                alt="Rhuna Logo" 
                className="h-10 w-auto object-contain"
              />
              <div>
                <h3 className="text-lg font-bold text-white">Rhuna Portal</h3>
                <p className="text-sm text-gray-400">Discover the Future of Events</p>
              </div>
            </div>
            
            {/* Social Media Icons */}
            <div className="flex space-x-3">
              <a 
                href="https://x.com/rhunaIO" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-600 transition-colors"
              >
                <svg className="w-4 h-4 text-gray-300" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a 
                href="https://t.me/rhunaio" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-600 transition-colors"
              >
                <Send className="w-4 h-4 text-gray-300" />
              </a>
              <a 
                href="https://discord.com/invite/6BQsQC8p2u" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-600 transition-colors"
              >
                <Image
                  src="https://pulsarmoney.b-cdn.net/rhuna/discord_icon_new.png"
                  alt="Discord"
                  width={16}
                  height={16}
                  className="w-4 h-4"
                />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Navigate</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/quests" className="text-gray-400 hover:text-white transition-colors">
                  Quests
                </Link>
              </li>
              <li>
                <Link href="/daily-lottery" className="text-gray-400 hover:text-white transition-colors">
                  Rhuna Forge
                </Link>
              </li>
              <li>
                <Link href="/leaderboard" className="text-gray-400 hover:text-white transition-colors">
                  Leaderboard
                </Link>
              </li>
              <li>
                <Link href="/referrals" className="text-gray-400 hover:text-white transition-colors">
                  Referrals
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Use and Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Need Help Section */}
        <div className="text-center mb-8">
          <p className="text-gray-400">
            Need Help? <a href="https://t.me/rhunaio" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#60FF8A] transition-colors">Contact support</a>
          </p>
        </div>

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-800/50">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
            <p className="text-sm text-gray-500">2025 Rhuna Portal. All rights reserved.</p>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-500">Powered by</span>
              <img 
                src="https://pulsarmoney.b-cdn.net/icons/logo-white.png" 
                alt="Pulsar.Money Logo" 
                className="w-6 h-3"
              />
              <a 
                href="https://www.pulsar.money/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm font-medium text-gray-500 hover:text-white transition-colors"
              >
                Pulsar.Money
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </footer>
  );
}
